import { Doctor } from "../doctor/doctor.interface";
import { Orderline } from "./orderline.inferface";
import { Company } from "../company/company.interface";

export interface Challan{
    id: number;
    challan_no: number;
    challan_date: Date;
    order_lines: Orderline[];
    job_id: string[];
    remark: string;
    shipment_id: number;
    is_invoiced: boolean;
    is_proforma_invoiced: string;
    doctor: Doctor;
    company: Company;
    doctor_id: number;
    doctor_name: string;
    company_name: string;
    job_type:  string;
    status: string;
};

export var displayColumns = [
    'challan_no',   
    'challan_date',
    'doctor_name',
    'job_type',
    'status',
    'is_proforma_invoiced',
    'company_name'
]

export var displayHeaders = [
    'Challan No.',   
    'Challan Date',
    'Doctor Name',
    'Job Type',
    'Status',
    'Is Proforma Invoiced',
    'Company Name'
]


// actual database columns
export var orderByColumns = [
    'challan_no',
    'challan_date',
    'doctor_name',
    'job_type',
    'status',
    'is_proforma_invoiced',
]


export const filterParameters = [
    { 
        name: 'job_date', 
        type: 'date_range', 
        operator: 'between', 
        label: 'Date Range' 
    },
    { 
        name: 'doctor_id', 
        type: 'dropdown', 
        operator: '=',
        model_name:'doctor',
        label: 'Doctor' 
    },
    { 
        name: 'company_id', 
        type: 'dropdown', 
        operator: '=',
        model_name:'company',
        label: 'Company' 
    },
    { 
        name: 'challan_no', 
        type: 'string', 
        operator: 'like', 
        label: 'Challan No.', 
    },
    { 
        name: 'job_type', 
        type: 'radio_option', 
        operator: '=',
        values: [
                    { label: 'Regular', value: "regular" },
                    { label: 'Repair', value: "repair" },
                    { label: 'Repeat', value: "repeat" }
                ],
        model_name:'challan',
        label: 'Job Type' 
    },
    { 
        name: 'status', 
        type: 'radio_option', 
        operator: '=',
        values: [
                    { label: 'Draft', value: "draft" },
                    { label: 'Submitted', value: "submitted" },
                    { label: 'Cancelled', value: "cancelled" }
                ],
        model_name:'challan',
        label: 'Status' 
    },
    { 
        name: 'is_proforma_invoiced', 
        type: 'radio_option', 
        operator: '=',
        values: [
                    { label: 'Yes', value: "true" },
                    { label: 'No', value: "false" },
                ],
        model_name:'challan',
        label: 'Is proforma Invoiced?' 
    },
    { 
        name: 'order_by_columns', 
        type: 'multi_select', 
        operator: 'order_by_columns',
        values: displayHeaders.map((header, index) => {
            if (header === 'Company Name') return null;
            return {
                label: header,
                value: orderByColumns[index]
            };
        }).filter(Boolean),
        model_name:'challan',
        label: 'Select columns for order by' 
    }
]  
